import { useLang } from "@/i18n";

export const Marquee = () => {
  const { t } = useLang();
  const words = [...t.marquee, ...t.marquee];
  return (
    <div data-testid="marquee" className="relative py-10 border-y border-[color:var(--line)] overflow-hidden">
      <div className="marquee-track flex w-max gap-12 whitespace-nowrap">
        {[...words, ...words].map((w, i) => (
          <span key={i} className="display italic text-5xl sm:text-7xl text-[color:var(--ink)]/80 flex items-center gap-12">
            {w}<span className="text-[color:var(--saffron)] text-2xl not-italic">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export const Stats = () => {
  const { t } = useLang();
  return (
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 py-16 grid grid-cols-2 lg:grid-cols-4 gap-y-10">
      {t.stats.map((s, i) => (
        <div key={i} data-testid={`stat-${i}`} className="border-l border-[color:var(--line)] pl-5 pr-3">
          <p className="display text-4xl sm:text-5xl text-[color:var(--gold)]">{s.value}</p>
          <p className="mt-2 text-sm text-[color:var(--muted)]">{s.label}</p>
        </div>
      ))}
    </div>
  );
};
